import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/tasks')({
  staticData: { crumb: 'tasks' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'tasks')
    requirePermission(context.session, 'tasks.read')
  },
  component: Outlet,
})
